import Cookie from 'js-cookie';

export async function getFacebookTrackingParameters() {
  const fbp = Cookie.get('_fbp');
  const fbc = Cookie.get('_fbc');

  const marketing = {};

  if (fbp && fbp.length > 0) {
    marketing.facebook_marketing_fbp = fbp;
  }

  if (fbc && fbc.length > 0) {
    marketing.facebook_marketing_fbc = fbc;
  }

  return marketing;
}
